/* 
   Purpose : Block and remove all advertising-related scripts
             injected dynamically by GTM, Shopify apps, or
             Shopify Customer Events.

   Targets :
     ✘  Amazon Ads         — amazon-adsystem.com / amzn.js
     ✘  Google Ads         — AW-782295241 / googleadservices / doubleclick
     ✘  Dynamic Remarketing — ecomm_prodid / ecomm_pagetype / google_tag_params
     ✘  Google Ad APIs     — googleapis.com (ad-serving endpoints only)

   Preserved (NOT removed) :
     ✔  Google Tag Manager — GTM-TSGFVN4
     ✔  Google Analytics 4 — G-W6MQ8YGD9H
     ✔  Google Fonts, Maps, reCAPTCHA, etc.
   ============================================================= */

(function () {
  'use strict';

  /* -------------------------------------------------------
     1. BLOCKED URL PATTERNS
     ------------------------------------------------------- */
  var blockedPatterns = [
    /* ---- Amazon Ads ---- */
    'amazon-adsystem.com',
    '/aat/amzn.js',

    /* ---- Google Ads ---- */
    'AW-782295241',
    'googleadservices.com',
    'googleads.g.doubleclick.net',

    /* ---- Dynamic Remarketing ---- */
    'google_tag_params',
    'ecomm_prodid',
    'ecomm_pagetype',
    'ecomm_totalvalue',

    /* ---- Google Ad-serving APIs ---- */
    'googleads.googleapis.com',
    'adservice.google.com'
  ];

  /**
   * Check whether a script src or inline content matches
   * any blocked advertising pattern.
   */
  function isBlockedScript(el) {
    if (!el || el.tagName !== 'SCRIPT') return false;

    var src = (el.src || '').toLowerCase();
    var text = (el.textContent || '').toLowerCase();

    for (var i = 0; i < blockedPatterns.length; i++) {
      var p = blockedPatterns[i].toLowerCase();
      if ((src && src.indexOf(p) !== -1) || (text && text.indexOf(p) !== -1)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Safely remove a script node from the DOM and log it.
   */
  function removeScript(el, reason) {
    if (el && el.parentNode) {
      el.parentNode.removeChild(el);
      console.log('[Ad Script Removal] Removed:', reason || el.src || '(inline script)');
    }
  }

  /* -------------------------------------------------------
     2. REMOVE EXISTING SCRIPTS ALREADY IN THE DOM
     ------------------------------------------------------- */
  var existing = document.querySelectorAll('script');
  for (var i = 0; i < existing.length; i++) {
    if (isBlockedScript(existing[i])) {
      removeScript(existing[i], existing[i].src);
    }
  }

  /* -------------------------------------------------------
     3. MUTATION OBSERVER — catch future injections
     ------------------------------------------------------- */
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var nodes = mutations[m].addedNodes;
        if (!nodes) continue;
        for (var n = 0; n < nodes.length; n++) {
          var node = nodes[n];

          /* Direct script node */
          if (node.tagName === 'SCRIPT' && isBlockedScript(node)) {
            removeScript(node, node.src);
            continue;
          }

          /* Script nested inside an added container */
          if (node.querySelectorAll) {
            var nested = node.querySelectorAll('script');
            for (var k = 0; k < nested.length; k++) {
              if (isBlockedScript(nested[k])) {
                removeScript(nested[k], nested[k].src);
              }
            }
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  /* -------------------------------------------------------
     4. INTERCEPT gtag() CALLS for Google Ads
        Prevents gtag('config', 'AW-...') and
        gtag('event', 'conversion', { send_to: 'AW-...' })
        while allowing GA4 and GTM calls through.
     ------------------------------------------------------- */
  function wrapGtag() {
    if (typeof window.gtag !== 'function') return;

    var _originalGtag = window.gtag;

    window.gtag = function () {
      var args = Array.prototype.slice.call(arguments);

      /* Block: gtag('config', 'AW-782295241', ...) */
      if (args[0] === 'config' && typeof args[1] === 'string' && args[1].indexOf('AW-') === 0) {
        console.log('[Ad Script Removal] Blocked gtag config:', args[1]);
        return;
      }

      /* Block: gtag('event', 'conversion', { send_to: 'AW-...' }) */
      if (args[0] === 'event' && args[2] && typeof args[2] === 'object') {
        var sendTo = args[2].send_to || '';
        if (typeof sendTo === 'string' && sendTo.indexOf('AW-') === 0) {
          console.log('[Ad Script Removal] Blocked gtag conversion event:', sendTo);
          return;
        }
      }

      /* Allow everything else (GA4, GTM, etc.) */
      return _originalGtag.apply(window, args);
    };
  }

  /* Wrap immediately if gtag exists, otherwise watch for it */
  if (window.gtag) {
    wrapGtag();
  } else {
    Object.defineProperty(window, 'gtag', {
      configurable: true,
      set: function (fn) {
        Object.defineProperty(window, 'gtag', {
          value: fn,
          writable: true,
          configurable: true
        });
        wrapGtag();
      },
      get: function () {
        return undefined;
      }
    });
  }

  /* -------------------------------------------------------
     5. BLOCK google_tag_params (Dynamic Remarketing)
        Prevents the remarketing data object from being read.
     ------------------------------------------------------- */
  if (typeof window.google_tag_params === 'undefined') {
    Object.defineProperty(window, 'google_tag_params', {
      configurable: true,
      set: function () {
        console.log('[Ad Script Removal] Blocked google_tag_params assignment');
      },
      get: function () {
        return undefined;
      }
    });
  }

  /* -------------------------------------------------------
     6. NEUTRALISE Amazon AAT object
        Prevents the Amazon tag from initialising even if
        amzn.js loaded before this script ran.
     ------------------------------------------------------- */
  if (typeof window.amznads !== 'undefined') {
    window.amznads = undefined;
  }
  try {
    Object.defineProperty(window, 'amznads', {
      configurable: true,
      set: function () {
        console.log('[Ad Script Removal] Blocked amznads initialisation');
      },
      get: function () {
        return undefined;
      }
    });
  } catch (e) { /* already defined — acceptable */ }

  console.log('[Ad Script Removal] Active — Amazon Ads, Google Ads, Dynamic Remarketing, and ad-serving APIs are being blocked.');
})();